<template>
    <el-main>
        <div class="breadcrumb-container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>Launcher Management</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/launcher/web-form' }">Web Forms</el-breadcrumb-item>
                <el-breadcrumb-item>Manage Web Form</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-row style="margin-top: 24px">
            <sticky :z-index="10" class-name="sub-navbar" sticky-class-name="stickied" >
                <div class="sticky-navbar overflow-hidden">
                    <el-col :span="16">
                        <div class="main-title">
                            Web Form Detail
                        </div>

                    </el-col>
                    <el-col :span="8" class="text-right">
                        <el-button type="success" size="mini" :disabled="!editingTitle && !editingFields && !editingTemplateHistory" @click="updateWebForm">Update Web Form</el-button>
                    </el-col>
                </div>
            </sticky>
        </el-row>

        <el-row type="flex" style="margin-top:24px">
            <el-col :span="24">
                <el-tabs v-model="activeTab" >
                    <el-tab-pane label="Active Template" name="activeTemplate" v-loading="loadingTemplates">
                        <el-form :rules="rules" ref="form" :model="form"  status-icon >
                            <el-card class="box-card mb-4">
                                <div slot="header" class="clearfix">
                                    <span>Web From Detail</span>
                                </div>
                                <div class="text item" >
                                    <el-row type="flex" class="row-bg" justify="center" v-if="webForm">
                                        <el-col :lg="12" :md="16" :sm="24">
                                            <el-form-item label="Country" label-width="100px">
                                                <b>{{webForm.country.name}}</b>
                                            </el-form-item>
                                            <el-form-item label="Title" prop="title" label-width="100px">
                                                <localized-input v-model="form.title" :local-key="webForm.country.code"></localized-input>
                                            </el-form-item>
                                            <el-form-item label="Remarks" prop="remarks" label-width="100px">
                                                <span v-if="webForm.activeTemplate">{{webForm.activeTemplate.remarks}}</span>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </div>
                            </el-card>
                            <el-card class="box-card" id="template-section">
                                <div slot="header" class="clearfix">
                                    <span >
                                        <span v-if="editingTemplateHistory">Template History</span>
                                        <span v-else>Active Template</span>
                                        <b v-if="form.templateId"> - {{this.form.templateId}}</b>
                                    </span>
                                    <el-tag
                                            class ="ml-4"
                                            size="mini"
                                            v-if="editingTemplateHistory"
                                            closable
                                            @close="backToActiveTemplate">Editing History</el-tag>
                                    <el-tag type="warning ml-4" size="mini" v-if="editingFields">Editing</el-tag>
                                    <el-tag type="danger ml-4" size="mini" v-if="templateHasError">Has Error(s)</el-tag>
                                </div>
                                <div class="text item fields-container" >
                                    <el-row type="flex" class="row-bg" justify="center" >
                                        <el-col :lg="16" :md="20" :sm="24">
                                            <el-alert
                                                    class="mb-2"
                                                    v-if="templateHasError"
                                                    title="One or more error detected on the template, please resolve highlighted items and try again."
                                                    type="error"
                                                    :closable="false">
                                            </el-alert>
                                            <el-alert
                                                    class="mb-2"
                                                    v-if="editingTemplateHistory"
                                                    title='You are editing previous version of the web form template from history.
                                                        Pressing "Update Web Form" button will use this selected version as the active template.
                                                        Close the "Editing History" tag above to return back to current active template.'
                                                    type="warning"
                                                    :closable="false">
                                            </el-alert>
                                            <el-collapse v-model="activeNames" accordion>
                                                <draggable :move="fieldDragged" v-model="form.fields" handle=".drag-handle">
                                                    <transition-group>
                                                        <el-collapse-item v-for="(element, index) in form.fields" :key="index" :name="index" >
                                                            <template slot="title" >
                                                                <div class="title-holder" :class="{'error-bg': element.hasError}">
                                                                    <span class="title-text"> <font-awesome-icon icon="bars" class="mr-2 ml-3 drag-handle"/>
                                                                        <span v-if="element.label.EN !== ''">{{element.label.EN}}</span>
                                                                        <span v-else>New Field</span>
                                                                    </span>
                                                                    <div class="spacer"></div>
                                                                    <div class="remove">
                                                                        <el-popover
                                                                                :ref="'popover'+index"
                                                                                placement="top"
                                                                                width="160"
                                                                                v-model="element.confirmDelete">
                                                                            <p class="mb-3">Delete field?</p>
                                                                            <div style="text-align: right; margin: 0">
                                                                                <el-button size="mini" type="text" @click.stop="element.confirmDelete = false">cancel</el-button>
                                                                                <el-button type="primary" size="mini" @click.stop="removeField(index)">confirm</el-button>
                                                                            </div>
                                                                            <el-button type="text" icon="el-icon-delete" slot="reference" @click.stop=""></el-button>
                                                                        </el-popover>

                                                                    </div>
                                                                </div>
                                                            </template>
                                                            <div class="pt-6 pl-4 pr-4 field-section">
                                                                <el-alert
                                                                        class="mb-2"
                                                                        v-if="element.hasError && element.label.EN === ''"
                                                                        title="Please enter at least EN value for the label."
                                                                        type="error"
                                                                        :closable="false">
                                                                </el-alert>
                                                                <el-alert
                                                                        class="mb-2"
                                                                        v-if="element.hasError && element.valueType === ''"
                                                                        title="Please select value type."
                                                                        type="error"
                                                                        :closable="false">
                                                                </el-alert>
                                                                <el-alert
                                                                        class="mb-2"
                                                                        v-if="element.hasError && element.hasEmptyOption"
                                                                        title="Please enter at least EN value for options."
                                                                        type="error"
                                                                        :closable="false">
                                                                </el-alert>
                                                                <el-alert
                                                                        class="mb-2"
                                                                        v-if="
                                                                            element.hasError &&
                                                                            (element.valueType === 'OPTION' ||
                                                                            element.valueType === 'MULTIPLE_OPTION') &&
                                                                            element.valueOptions.length === 0
                                                                        "
                                                                        title="Please add at least 1 option."
                                                                        type="error"
                                                                        :closable="false">
                                                                </el-alert>

                                                                <el-form-item
                                                                        class="mt-3"
                                                                        label="Label"
                                                                        label-width="100px"
                                                                        :required="true">
                                                                    <localized-input v-model="element.label" :local-key="webForm.country.code"></localized-input>
                                                                </el-form-item>
                                                                <el-form-item label="Type" label-width="100px">
                                                                    <el-select
                                                                            style="width: 100%"
                                                                            v-model="element.valueType"
                                                                            filterable
                                                                            placeholder="Select Type">
                                                                        <el-option
                                                                                v-for="item in valueTypes"
                                                                                :key="item.key"
                                                                                :label="item.label"
                                                                                :value="item.key">
                                                                        </el-option>
                                                                    </el-select>
                                                                </el-form-item>
                                                                <div class="overflow-hidden p-4 pt-0" v-if="element.valueType === 'OPTION' || element.valueType === 'MULTIPLE_OPTION'">

                                                                    <el-divider content-position="left" >Manage Options</el-divider>
                                                                    <el-collapse v-model="element.activeNames" accordion>
                                                                        <draggable v-model="element.valueOptions" handle=".drag-handle">
                                                                            <transition-group>
                                                                                <el-collapse-item v-for="(option, optionIndex) in element.valueOptions" :key="optionIndex" :name="optionIndex" class="field-title">
                                                                                    <template slot="title" >
                                                                                        <div class="title-holder">
                                                                                            <span > <font-awesome-icon icon="bars" class="mr-2 ml-3 drag-handle"/>
                                                                                                <span v-if="option.localizedStringMap.EN !== ''">{{option.localizedStringMap.EN}}</span>
                                                                                                <span v-else>New Option</span>
                                                                                            </span>
                                                                                            <div class="spacer"></div>
                                                                                            <div class="remove"><el-button type="text" icon="el-icon-delete" @click.stop="removeFieldOption(element.valueOptions, optionIndex)"></el-button> </div>
                                                                                        </div>
                                                                                    </template>
                                                                                    <div class="pt-6 pl-4 pr-4 field-section">
                                                                                        <el-form-item
                                                                                                label="Label"
                                                                                                label-width="100px"
                                                                                                :required="true">
                                                                                            <localized-input v-model="option.localizedStringMap" :local-key="webForm.country.code"></localized-input>
                                                                                        </el-form-item>
                                                                                    </div>
                                                                                </el-collapse-item>
                                                                            </transition-group>
                                                                        </draggable>
                                                                    </el-collapse>
                                                                    <div class="overflow-hidden border-b text-center">
                                                                        <el-button style="width: 100%" type="text" @click="addFieldOption(element)" icon="el-icon-plus">Add Option</el-button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </el-collapse-item>

                                                    </transition-group>

                                                </draggable>
                                            </el-collapse>
                                            <div class="overflow-hidden border-b text-center">
                                                <el-button style="width: 100%" type="text" @click="addField" icon="el-icon-plus">Add Field</el-button>
                                            </div>
                                        </el-col>
                                    </el-row>
                                </div>
                            </el-card>
                        </el-form>
                    </el-tab-pane>
                    <el-tab-pane label="Templates History" name="templateHistory">
                        <el-card class="box-card">
                            <div slot="header" class="clearfix">
                                <span>Web From Template History Record</span>
                            </div>
                            <div class="text item">
                                <el-table
                                        :data="templates"
                                        @expand-change="historyExpandChange"
                                        stripe
                                        style="width: 100%">
                                    <el-table-column type="expand">
                                        <template slot-scope="props" v-loading="props.row.loading">
                                            <div>
                                                <div class="mb-3 text-right">
                                                    <el-button type="warning" size="mini" @click="editHistoryTemplate(props.row)">Edit</el-button>
                                                </div>
                                                <form-preview :form="props.row"></form-preview>
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            prop="versionId"
                                            label="Version ID">
                                    </el-table-column>
                                    <el-table-column
                                            prop="createdBy"
                                            label="By">
                                    </el-table-column>
                                    <el-table-column
                                            label="Date">
                                        <template slot-scope="scope" >
                                            {{scope.row.createdDate | formatDate}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            prop="remarks"
                                            label="Remarks">
                                    </el-table-column>
                                </el-table>
                            </div>
                        </el-card>
                    </el-tab-pane>
                </el-tabs>

            </el-col>
        </el-row>

        <el-dialog title="Save Template" :visible.sync="showTemplateDialog" >
            <div v-loading="saving">
                <p style="word-break: normal">A change to the current template detected. Proceed to submit will generate a new version of the template.</p>
                <el-divider/>
                <el-form :model="form" ref="templateForm" >

                    <el-form-item label="Remarks" >
                        <el-input type="textarea" v-model="form.remarks"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="showTemplateDialog = false">Cancel</el-button>
                <el-button size="small" type="primary" @click="doSubmitTemplate()">Save</el-button>
            </span>
        </el-dialog>
    </el-main>
</template>

<script>
import _ from 'lodash'
import api from '@/services/api/WRCService'
import draggable from 'vuedraggable'
import localizedInput from '@/components/LocalizedInput'
import sticky from '@/components/Sticky'
import formPreview from '@/components/FormPreview'
import moment from 'moment'

export default {
    props: ['webFormId'],
    components: {
        draggable,
        localizedInput,
        sticky,
        formPreview
    },
    data: function() {
        return {
            editingTemplateHistory : false,
            templateHasError : false,
            showTemplateDialog: false,
            saving: false,
            editingTitle: false,
            editingFields: false,
            activeNames: '',
            activeTab: "activeTemplate",
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now();
                }
            },
            loadingTemplates: false,
            loading: false,
            webForm: '',
            templates: [],
            valueTypes:[
                { key: "TEXT", label : "Text"},
                { key: "INT", label : "Number"},
                { key: "BOOLEAN", label : "Yes / No"},
                { key: "DATE", label : "Date"},
                { key: "OPTION", label : "Multiple Options"},
                { key: "MULTIPLE_OPTION", label : "Multiple Answers"},

            ],
            form: {
                title: '',
                remarks: '',
                fields : []
            },
            message: 'test'
        }
    },
    computed: {
        rules() {
            return {
                title: [
                    {required: true, message: "Please enter title", trigger: 'blur'}
                ],
                fieldName: [
                    {required: true, message: "Field name is required", trigger: 'blur'}
                ]
            }
        },
        hasUpdate() {
            return false
        },
        fields() {
            return this.form.fields;
        },
        title() {
            return this.form.title;
        }
    },
    methods: {
        isActiveField(fieldId) {
            return this.activeNames === fieldId
        },
        updateWebForm() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    if (!this.editingFields && !this.editingTemplateHistory) {

                        this.loadingTemplates = true

                        let params = {
                            webFormId: this.webFormId,
                            title: this.form.title
                        }

                        api.updateWebForm(params).then(({data}) => {
                            this.$message({
                                message: 'Successfully Updated Web Form.',
                                type: 'success'
                            })

                            this.$router.push('/launcher/web-form')
                        }).catch(() => {
                        }).then(() => {
                            this.loadingTemplates = false
                        })
                    } else {
                        if (this.validateFields()) {
                            this.templateHasError = false
                            this.showTemplateDialog = true
                        } else {
                            this.templateHasError = true
                            document.getElementById("template-section").scrollIntoView(true);
                        }
                    }
                }
            })
        },
        doSubmitTemplate() {
            this.saving = true

            let params = {
                webFormId: this.webFormId,
                title: this.form.title,
                remarks: this.form.remarks,
                fields: []
            }

            this.form.fields.forEach(field => {
                let theField = {
                    valueType: field.valueType,
                    name: field.label.EN,
                    label: field.label,
                }

                if (this.isOptionField(field)) {
                    theField.valueOptions = []

                    field.valueOptions.forEach(valueOption => {

                        theField.valueOptions.push(valueOption.localizedStringMap)
                    })
                }

                params.fields.push(theField)
            })

            api.createWebFormTemplate(params).then(({data}) => {
                this.$message({
                    message: 'Successfully Created New Web Form Template.',
                    type: 'success'
                })

                this.$router.push('/launcher/web-form')
            }).catch(() => {
            }).then(() => {
                this.saving = false
            })
        },
        isOptionField(field) {
            return (field.valueType === "OPTION" || field.valueType === "MULTIPLE_OPTION")
        },
        validateFields() {
            let valid = true;

            this.form.fields.forEach(field => {
                if (
                    field.label.EN === '' ||
                    field.valueType === '' ||
                    (this.isOptionField(field) && field.valueOptions.length === 0) ) {
                    valid = false
                    this.$set(field, 'hasError', true)
                }

                if (this.isOptionField(field)) {
                    field.valueOptions.forEach(option => {
                        if (option.localizedStringMap.EN === '') {
                            valid = false
                            this.$set(field, 'hasError', true)
                            this.$set(field, 'hasEmptyOption', true)
                        }
                    })
                }
            })

            return valid
        },
        updateInputForm(webform) {
            this.form.title = webform.title

            if (webform.activeTemplate) {

                this.updateActiveTemplate(webform.activeTemplate)
            } else {
                this.form.remarks = "";
            }

            setTimeout(() => {
                this.editingTitle = false
            }, 1);
        },
        updateActiveTemplate(template) {
            this.form.templateId = template.versionId

            this.form.fields.splice(0, this.form.fields.length)
            this.form.fields.push(...template.fields)

            this.templateHasError = false
            setTimeout(() => {
                this.editingFields = false
            }, 1);

        },
        editHistoryTemplate(template) {
            this.activeTab = 'activeTemplate'

            this.editingTemplateHistory = true

            this.updateActiveTemplate(template)

            setTimeout(() => {
                document.getElementById("template-section").scrollIntoView(true);
            }, 1);
        },
        backToActiveTemplate() {
            this.editingTemplateHistory = false
            this.updateActiveTemplate(this.webForm.activeTemplate)
        },
        fieldDragged(evt, originalEvent){
            this.activeNames = ''
            return true
        },
        addField() {
            let field = {
                label: {
                    'EN' : ''
                },
                valueType: '',
                valueOptions: []
            }

            field[this.webForm.country.code] = ''

            this.form.fields.push(field)

            this.activeNames = this.form.fields.length - 1
        },
        removeField(index) {
            this.form.fields.splice(index, 1)
        },
        addFieldOption(field) {
            if (_.isUndefined(field.valueOptions) || field.valueOptions === null) {
                field.valueOptions = []
            }

            let option = {
                localizedStringMap : {
                    'EN': ''
                }
            }

            option.localizedStringMap[this.webForm.country.code] = ''

            field.valueOptions.push(option)

            field.activeNames = field.valueOptions.length - 1
        },
        removeFieldOption(options, index) {
            options.splice(index, 1)
        },
        loadHistoryFields(row) {
            row.loading = true

            api.getWebFormTemplate(this.webFormId, row.id).then(({ data }) => {

                row.isLoaded = true
                row.fields = data.data.fields

            }).catch(() => {}).then(() => {
                row.loading = false;
            });
        },
        historyExpandChange(row, expandedRows) {

            if (!row.isLoaded) {
                this.loadHistoryFields(row)
            }
        },
        loadTemplates() {
            this.loadingTemplates = true;

            api.getWebFormTemplates(this.webFormId, {
                page: 0,
                pageSize: 100
            }).then(({ data }) => {

                let templates = data.data.items;

                templates.forEach(data => {
                    data.isLoaded = false
                    data.loading = false
                    data.fields = []
                });

                this.templates.splice(0, this.templates.length);
                this.templates.push(...templates);
            }).catch(() => {}).then(() => {
                this.loadingTemplates = false;
            });
        }
    },
    mounted() {
        if (!_.isUndefined(this.webFormId)) {
            this.loading = true

            api.getWebForm(this.webFormId).then(({data}) =>{
                this.webForm = data.data

                this.updateInputForm(this.webForm)
            }).catch(() => {}).then(() => {
                this.loading = false
            })

            this.loadTemplates();
        }
    },
    watch: {
        fields: {
            handler(val) {
                this.editingFields = true
            },
            deep: true
        },
        title: {
            handler(val) {
                this.editingTitle = true
            }
        }
    }
}
</script>
<style>
    .fields-container .el-collapse-item__wrap {
        background-color: #eef0f6 !important;
    }

    .fields-container .el-divider__text {
        background-color: #eef0f6 !important;
    }
</style>

<style scoped>
    .stickied .sticky-navbar {
        padding-top: 0.6em;
        padding-bottom: 0.6em;
        border-bottom-width: 1px;
    }
    .error-bg .title-text {
        color: #fa745f;
    }

    .title-holder:hover  .drag-handle {
        visibility: visible;
    }

    .title-holder .drag-handle {
        visibility: hidden;
    }

    .fields-container .title-holder {
        display: flex;
        width: 100%;
        margin-right: 1em;
    }

    .fields-container .title-holder .spacer {
        flex-grow: 1;
    }

    .title-holder:hover .remove {
        visibility: visible;
    }

    .title-holder .remove {
        visibility: hidden;
    }
</style>